const RemoveAttach = () => {
  document.querySelector(".trix-button-group--file-tools").classList.add("d-none");
}

export { RemoveAttach }
